import { reactive } from 'vue';

const languageState = reactive({
  language: localStorage.getItem('language') || 'es'
});

function setLanguage(languageCode: string) {
    localStorage.setItem('language', languageCode);
    languageState.language = languageCode;
    document.documentElement.lang = languageCode;
  }

function getLanguage() {
    return languageState.language;
}

export default {
  languageState,
  setLanguage,
  getLanguage
};
